module.exports = __webpack_public_path__ + "public/images/program/program-10.5b96111b9bb6c4e37f7ad358c021b71f.png";